import { render, staticRenderFns } from "./I360Viewer.vue?vue&type=template&id=134b4d15&"
import script from "./I360Viewer.vue?vue&type=script&lang=js&"
export * from "./I360Viewer.vue?vue&type=script&lang=js&"
import style0 from "./I360Viewer.vue?vue&type=style&index=0&id=134b4d15&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports